import React, { useEffect, useState } from 'react';
import { Check } from 'lucide-react';
import './requestProgress.scss';

// instant: درخواستِ قبلی (نه همین الان ثبت‌شده) — نوارِ ارسال دوباره پر نشود، از اول «ارسال شد» نشان داده شود
function RequestProgress({ sendMethod, targetCount, instant = false }) {
  const [current, setCurrent] = useState(instant ? targetCount : 0);
  const [isDone, setIsDone] = useState(instant);

  useEffect(() => {
    let cancelled = false;
    let intervalId = null;
    let timeoutId = null;

    if (instant) {
      setCurrent(targetCount);
      setIsDone(true);
      return undefined;
    }
    setCurrent(0);
    setIsDone(false);

    if (sendMethod === 'free') {
      // ارسال رایگان: نوار سریع (حدود ۸۰۰ میلی‌ثانیه) پر می‌شود
      const duration = 800;
      const steps = 24;
      const stepTime = duration / steps;
      let step = 0;

      intervalId = setInterval(() => {
        if (cancelled) return;
        step += 1;
        const progress = Math.min(step / steps, 1);
        setCurrent(Math.round(progress * targetCount));
        if (step >= steps) {
          clearInterval(intervalId);
          setCurrent(targetCount);
          setIsDone(true);
        }
      }, stepTime);
    } else {
      // ارسال پیامکی: هر بار حدود ۱۰ نفر با تاخیر رندوم بین ۰.۱ تا ۱ ثانیه اضافه می‌شود
      let value = 0;

      const tick = () => {
        if (cancelled) return;
        const increment = Math.min(10, targetCount - value);
        value += increment;
        setCurrent(value);

        if (value >= targetCount) {
          setIsDone(true);
          return;
        }
        const delay = Math.random() * (1000 - 100) + 100;
        timeoutId = setTimeout(tick, delay);
      };

      tick();
    }

    return () => {
      cancelled = true;
      if (intervalId) clearInterval(intervalId);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [sendMethod, targetCount, instant]);

  const percent = targetCount > 0 ? Math.min((current / targetCount) * 100, 100) : 0;

  return (
    <div className={`request-progress ${isDone ? 'is-done' : ''}`}>
      {isDone ? (
        <div className="request-progress__done">
          <Check size={15} strokeWidth={2.4} />
          <span>درخواست به {targetCount.toLocaleString('fa-IR')} مشاور ارسال شد</span>
        </div>
      ) : (
        <>
          <div className="request-progress__bar-track">
            <div className="request-progress__bar-fill" style={{ width: `${percent}%` }} />
          </div>
          <div className="request-progress__count">
            <span>در حال ارسال...</span>
            <span>
              {current.toLocaleString('fa-IR')}/{targetCount.toLocaleString('fa-IR')}
            </span>
          </div>
        </>
      )}
    </div>
  );
}

export default RequestProgress;